/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
// import { RouteComponentProps } from 'react-router-dom'
import styled from 'styled-components'
import { EditOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Col, Row, Space, Input, Badge } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Data, ListReq } from 'Store/coupon/types'
import { selectList, selectListEvent } from 'Store/coupon/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { formatDateWithoutTime, getCouponStatus, numberWithComma, toDateQuery } from 'helpers/format'
import { StatusTag } from 'Components/utilities'
import { TableListPage } from 'Components/common/Table'
import { ActionButton, PrimaryButton } from 'Components/button'
import HomePageLayout from 'Pages/Layout/PageLayout'
import Detail from './detail'
import { Pagination } from 'Components/Pagination'
import { couponListAPI } from 'Store/coupon/api'
import { CouponType, CouponTypeText, menuCouponStatusFilter } from 'helpers/constanst'
import { MyTheme } from 'Components/common/Theme'
import { RangeDateItem, SelectItem } from 'Components/form'

type Props = {} & ReduxProps

const Coupon: React.FunctionComponent<Props> = props => {
  const { currentUser, listEvent, dataList } = props
  const dispatch = useDispatch()
  const [drawer, setDrawer] = useState(false)
  const [selectedID, setSelectedID] = useState(0)
  const [pageMode, setPageMode] = useState('create' as 'create' | 'edit')

  const [filter, setFilter] = useState({
    keyword: '',
    start_date: '',
    end_date: '',
    status: '',
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })
  const meta = dataList.meta
  const datas = dataList.data

  const onGetDataList = (): void => {
    const req: ListReq = {
      keyword: filter.keyword?.trim() || '',
      start_date: toDateQuery(filter.start_date),
      end_date: toDateQuery(filter.end_date),
      status: filter.status,
      page: pagination.Page,
      per_page: pagination.RowPerPage,
    }
    dispatch(couponListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetDataList()
    }
  }, [pagination])

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const handleChangeDate = (statDate: string, endDate: string) => {
    setFilter({
      ...filter,
      start_date: statDate,
      end_date: endDate,
    })
  }

  const onOpenDrawer = () => {
    setDrawer(true)
  }

  const onCloseDrawer = () => {
    setDrawer(false)
  }

  const onClickCreate = () => {
    setPageMode('create')
    setSelectedID(0)
    onOpenDrawer()
  }

  const onClickEdit = (id: number) => {
    setPageMode('edit')
    setSelectedID(id)
    onOpenDrawer()
  }

  const onSuccess = () => {
    onCloseDrawer()
    onGetDataList()
  }

  const renderStatus = (publish: boolean, record: any) => {
    let color = 'green'
    if (record.message === 'แคมเปญยังไม่ถึงช่วงเวลาแจกคูปอง') {
      color = 'yellow'
    }
    if (record.message === 'แคมเปญเกินกำหนดเวลากำหนดแจกคูปอง') {
      color = 'red'
    }
    return (
      <>
        <StatusTag isPass={publish} text={getCouponStatus(publish)} />
        {record.message !== '' && (
          <RemarkText>
            <Badge color={color} />
            {record.message}
          </RemarkText>
        )}
      </>
    )
  }

  const renderType = (discount_type: CouponType) =>
    discount_type === CouponType.AMOUNT ? CouponTypeText.AMOUNT : CouponTypeText.PERCENT

  const countBadge = (count: number) => numberWithComma(count)

  const renderCount = (color: string, title: string, count: number) => (
    <DetailText>
      <Row justify="space-between" align="middle">
        <Col>
          <Badge color={color} />
          {title}
        </Col>
        <Col> {countBadge(count)} ใบ</Col>
      </Row>
    </DetailText>
  )

  const renderDetail = (total_coupon: number, record: Data) => {
    return (
      <>
        {renderCount('grey', 'จำนวนทั้งหมด', total_coupon)}
        {renderCount('yellow', 'แจกไปแล้ว', record.total_give)}
        {renderCount('green', 'ใช้แล้ว', record.total_used)}
        {renderCount('red', 'หมดอายุแล้ว', record.total_expired)}
      </>
    )
  }

  const renderActionButton = (text: string, record: any) => (
    <Space size="middle">
      <ActionButton
        text=""
        icon={<EditOutlined />}
        label="แก้ไข"
        action="edit"
        onClick={() => onClickEdit(record.id)}
      />
    </Space>
  )

  const columns = [
    {
      title: 'ชื่อโปรโมชั่น',
      dataIndex: 'campaign_name',
      key: 'campaign_name',
      width: '200px',
    },
    {
      title: 'ประเภทส่วนลด',
      dataIndex: 'discount_type',
      key: 'discount_type',
      render: renderType,
    },
    {
      title: 'มูลค่า',
      dataIndex: 'discount_amount',
      key: 'discount_amount',
      width: '100px',
    },
    {
      title: 'วันที่เริ่มต้น',
      key: 'start_date',
      dataIndex: 'start_date',
      render: (date: string) => formatDateWithoutTime(date),
    },
    {
      title: 'วันที่สิ้นสุด',
      key: 'end_date',
      dataIndex: 'end_date',
      render: (date: string) => formatDateWithoutTime(date),
    },
    {
      title: 'สถานะ',
      key: 'publish',
      dataIndex: 'publish',
      render: renderStatus,
      width: '250px',
    },
    {
      title: 'จำนวนคูปอง',
      dataIndex: 'total_coupon',
      key: 'total_coupon',
      render: renderDetail,
      width: '180px',
    },
    {
      title: 'แก้ไข',
      key: 'action',
      render: renderActionButton,
    },
  ]

  const DetailDrawer = (
    <Detail
      mode={pageMode}
      id={selectedID}
      visible={drawer}
      onCloseDrawer={onCloseDrawer}
      onSuccess={onSuccess}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="space-between" align="bottom">
        <MyCol xs={24} md={20}>
          <Row gutter={[16, 16]}>
            <Col md={7} xs={24}>
              <SearchInput
                placeholder="ค้นหาชื่อโปรโมชั่น"
                prefix={<SearchOutlined />}
                allowClear
                value={filter.keyword}
                onChange={(evt: any): void => onFilter('keyword', evt.target.value)}
              />
            </Col>
            <Col md={7} xs={24}>
              <SelectItem
                name={'status'}
                label={''}
                isRequired={true}
                value={filter.status}
                menu={menuCouponStatusFilter}
                placeHolder={'สถานะ'}
                onChange={(val: any): void => onFilter('status', val)}
              />
            </Col>
            <Col md={7} xs={24}>
              <RangeDateItem
                placeHolder={['วันที่เริ่มต้น', 'สิ้นสุด']}
                onChange={handleChangeDate}
                startDate={filter.start_date}
                endDate={filter.end_date}
              />
            </Col>
            <Col>
              <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
            </Col>
          </Row>
        </MyCol>
        <MyCol>
          <Space size="middle">
            <PrimaryButton text="เพิ่มแคมเปญคูปอง" icon={<PlusOutlined />} onClick={onClickCreate} />
          </Space>
        </MyCol>
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  return (
    <>
      <HomePageLayout selected="coupons" title="จัดการแคมเปญคูปอง">
        {FilterContent}
        <TableListPage
          columns={columns}
          datas={datas}
          isLoading={listEvent.IsLoading}
          paginationContent={PaginationContent}
        />
        {DetailDrawer}
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    dataList: selectList(state),
    listEvent: selectListEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const MyCol = styled(Col)`
  margin-top: 10px;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`

const DetailText = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  font-weight: 100;
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.regular};
  padding-right: 10px;
`
const RemarkText = styled.div`
  margin-top: 5px;
  font-size: 13px;
`

export default connect(mapStateToProps)(Coupon)
